import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (dismissed) return null;

  return (
    <div className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-500 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
      <div className="bg-white/97 backdrop-blur-xl border-t border-slate-200/80 shadow-2xl">
        <div className="max-w-5xl mx-auto px-4 py-3 sm:py-3.5 flex items-center justify-between gap-3">
          {/* Info */}
          <div className="hidden sm:flex items-center gap-4">
            <div className="w-9 h-9 rounded-xl overflow-hidden flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/a17d3ae5e640a18a289681692364ae47/fc2ed0bd71fb688a40f03f8096cc646d.jpeg"
                alt="UzunDigital"
                className="w-full h-full object-cover"
                loading="lazy"
                width="36"
                height="36"
              />
            </div>
            <div>
              <p className="text-slate-900 font-bold text-sm whitespace-nowrap">Votre site pro en 7 jours max</p>
              <p className="text-slate-500 text-xs font-medium">À partir de 69€/mois · Sans engagement</p>
            </div>
          </div>

          {/* CTAs */}
          <div className="flex items-center gap-2 flex-1 sm:flex-none justify-end">
            <a
              href="tel:+33651872435"
              className="hidden sm:flex items-center gap-2 border-2 border-slate-200 text-slate-700 px-5 py-2.5 rounded-full text-sm font-semibold hover:border-emerald-400 hover:text-emerald-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-emerald-500"></i>
              <span>Appeler</span>
            </a>
            <Link
              to="/offres"
              className="flex items-center gap-2 bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-6 sm:px-8 py-2.5 rounded-full text-sm font-bold hover:shadow-lg hover:shadow-emerald-500/35 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-price-tag-3-line text-base"></i>
              <span>Voir nos offres</span>
            </Link>
          </div>

          {/* Close */}
          <button
            onClick={() => setDismissed(true)}
            className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-slate-100 transition-colors cursor-pointer flex-shrink-0 ml-1"
            aria-label="Fermer"
          >
            <i className="ri-close-line text-slate-400 text-base"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
